import {
	RECEIVE_TIMESLOT_DATA,
	SET_TIMESLOT_RULES,
	RECEIVE_TIMESLOT_RULES,
	RECEIVE_TIMESLOTS,
	RECEIVE_TIMESLOT_ENABLED,
} from './types';

const initialState = {
	enabled: false,
	// synchronisation de l'état des produits avec la caisse.
	// null/undefined = traité comme true côté UI ; seul false explicite désactive.
	timeslot_pos: null,
	timeslots: [],
	rules: [],
};

// comparaison tolérante number/string (l'id peut arriver en string depuis le parent)
const sameId = (a, b) => a != null && b != null && String(a) === String(b);

const reducer = function timeslotReducer(state = initialState, action) {
	switch (action.type) {
		case RECEIVE_TIMESLOT_DATA:
			return {
				enabled: action.data.enabled,
				timeslot_pos: action.data.timeslotPos,
				timeslots: action.data.timeslots,
				rules: action.data.rules,
			};
		case SET_TIMESLOT_RULES: {
			const isProduct = action.entityType === 'product';
			const idField = isProduct ? 'idProduct' : 'idSection';
			// on retire les rules existantes de cette section/produit
			const otherRules = state.rules.filter(
				rule => !sameId(rule[idField], action.id)
			);
			// puis on ajoute la nouvelle sélection
			const newRules = action.rules.map(({ idTimeslot, rule }) => ({
				idProduct: isProduct ? action.id : null,
				idSection: isProduct ? null : action.id,
				idTimeslot,
				rule,
			}));
			return {
				...state,
				rules: [...otherRules, ...newRules],
			};
		}
		case RECEIVE_TIMESLOT_RULES:
			// le back renvoie uniquement les rules à jour
			return {
				...state,
				rules: action.rules,
			};
		case RECEIVE_TIMESLOTS:
			// le back renvoie uniquement les timeslots à jour (après sauvegarde du draft)
			return {
				...state,
				timeslots: action.timeslots,
			};
		case RECEIVE_TIMESLOT_ENABLED:
			// reflète l'état persisté après sauvegarde du draft
			return {
				...state,
				enabled: action.enabled,
				// timeslot_pos est persisté avec enabled (réglage global)
				...(action.timeslot_pos !== undefined
					? { timeslot_pos: action.timeslot_pos }
					: {}),
			};
		default:
			return state;
	}
};

export default reducer;
